export const PageConfig = {
  pages: [
    // A
    {
      label: "ACCOUNT CONFIG",
      routerLink: "/account-config",
      priv: "ACCOUNT_CONFIG",
    },
    {
      label: "ACCOUNT MAPPING",
      routerLink: "/accountmapping",
      priv: "ACCOUNT_MAPPING",
    },
    {
      label: "ASSET CLASS CONFIG",
      routerLink: "/asset-class-config",
      priv: "ASSET_CLASS_CONFIG",
    },
    {
      label: "AUDIT TRAIL",
      routerLink: "/audittrail",
      icon: "fa fa-user",
      priv: "AUDIT_TRAIL",
    },
    {
      label: "Aum Query",
      routerLink: "/aumquery",
      priv: "EXT_AUM",
    },
    // B
    // C
    {
      label: "CA CONFIG",
      routerLink: "/caconfig",
      priv: "CA_CONFIG",
    },
    {
      label: "CASE DETAILS",
      routerLink: "/case/:id",
      icon: "fa fa-users",
      priv: "CASE_DETAILS_VIEW",
    },
    {
      label: "CODE CONFIG",
      routerLink: "/code-config",
      priv: "CODE_CONFIG",
    },
    {
      label: "CREDIT RATING",
      routerLink: "/credit-rating-capture",
      priv: "CREDIT_RATING",
    },
    // D
    {
      label: "D&C CONFIG",
      routerLink: "/dc-config",
      priv: "DC_CONFIG",
    },
    {
      label: "Dashboard",
      routerLink: "/ccass",
      priv: "DASHBOARD_CC_IFRAME",
    },
    {
      label: "DAILY C/R ORDERS MANAGEMENT",
      routerLink: "/dailycrordrsmgmt",
      priv: "DAILY_CR_ORDERS_MGMT",
    },
    {
      label: "DATA MARKET PLACE",
      routerLink: "/datamarketplace",
      priv: "DATA_MARKET_PLACE",
    },
    // E
    {
      label: "EMAIL GENERATION",
      routerLink: "/emailgeneration",
      priv: "EMAIL_GENERATION",
    },
    {
      label: "ENUM CONFIG",
      routerLink: "/enum-config",
      priv: "ENUM_CONFIG",
    },
    {
      label: "EOD Distributor",
      routerLink: "/eoddistributor",
      priv: "EOD_DISTRIBUTOR",
    },
    {
      label: "ETF_REBALANCE",
      routerLink: "",
      priv: "ETF_REBALANCE",
    },
    {
      label: "Ext Aum",
      routerLink: "/extaum",
      priv: "EXT_AUM",
    },
    // F
    {
      label: "FIRM LEVEL LIQUIDITY",
      routerLink: "/firmliquidation",
      priv: "FIRM_LEVEL_LIQUIDITY",
    },
    {
      label: "FIRM LEVEL SUSPENDED STOCKS",
      routerLink: "/suspendedstocks",
      priv: "FIRM_LEVEL_SUSPENDED_STOCK",
    },
    {
      label: "FUNDS",
      routerLink: "/managefunds",
      icon: "fa fa-user",
      priv: "MANAGE_FUNDS",
    },
    {
      label: "FX RATES",
      routerLink: "/opsfxrate",
      priv: "OPS_FX_RATES",
    },
    // G
    // H
    {
      label: "HOLIDAY CALENDAR",
      routerLink: "/holidaycalender",
      priv: "HOLIDAY_CALENDER",
    },
    // I
    // J
    {
      label: "JOBS",
      routerLink: "/jobs",
      icon: "fa fa-users",
      priv: "MANAGE_JOBS",
    },
    {
      label: "JOBS(New)",
      routerLink: "/jobsConfig",
      icon: "fa fa-users",
      priv: "MANAGE_JOBS",
    },
    // K
    {
      label: "KYC SUMMARY",
      routerLink: "/kycdashboard",
      icon: "fa fa-users",
      priv: "KYC_DASHBOARD",
    },
    // L
    // M
    {
      label: "MAILS CONFIG",
      routerLink: "/emailconfig",
      priv: "MAIL_CONFIG",
    },
    {
      label: "MONITOR DATA",
      routerLink: "/monitorData",
      priv: "MONITOR_DATA",
    },
    
    // N
    // O
    // P
    {
      label: "PARTIES",
      routerLink: "/parties",
      priv: "PARTIES",
    },
    {
      label: "PEER FUNDS",
      routerLink: "/peerfunds",
      priv: "MANAGE_PEER_FUND",
    },
    {
      label: "PORTFOLIO CODES",
      routerLink: "/portfoliocodes",
      priv: "PORTFOLIOCODE_MAPPING",
    },
    {
      label: "PREMIUM DISCOUNT",
      routerLink: "/premiumdiscount",
      priv: "PREMIUM_DISCOUNT",
    },
    {
      label: "PREMIUM DISCOUNT SUMMARY",
      routerLink: "/pdsummary",
      priv: "PREMIUM_DISCOUNT_SUMMARY",
    },
    {
      label: "PRICES",
      routerLink: "/pricemaintainance",
      priv: "PRICES",
    },

    // Q
    {
      label: "Quant FX RATES",
      routerLink: "/fxrate",
      priv: "FX_RATE",
    },
    // R
    {
      label: "RECON CONFIGURATION",
      routerLink: "/reconconfig",
      priv: "RECON_CONFIGURATION",
    },
    {
      label: "REPORT",
      routerLink: "",
      priv: "REPORT",
    },
    {
      label: "Reset Password",
      routerLink: "/resetpassword",
      icon: "fa fa-user",
      priv: "RESET_PWD",
    },
    {
      label: "ROLES",
      routerLink: "/roles",
      icon: "fa fa-users",
      priv: "MANAGE_ROLES",
    },
    // S
    {
      label: "SCHEDULER CONFIG",
      routerLink: "/schedule",
      icon: "fa fa-users",
      priv: "SCHEDULER",
    },
    // T
    {
      label: "TD THRESHOLD",
      routerLink: "/tdthreshold",
      priv: "TD_THRESHOLD",
    },
    {
      label: "TEMPLATE MAPPING",
      routerLink: "/newslettermapping",
      priv: "NEWSLETTER_MAPPING",
    },
    {
      label: "TEMPLATE DESIGN",
      routerLink: "/newsletters",
      priv: "NEWSLETTER_CREATE",
    },
    {
      label: "TEMPLATES FOR APPROVAL",
      routerLink: "/requestedtemplates",
      priv: "NEWSLETTER_APPROVE",
    },
    {
      label: "TEMPLATE REPORTS",
      routerLink: "/newsletterreport",
      priv: "NEWSLETTER_REPORTS",
    },
    {
      label: "TRANSACTIONS",
      routerLink: "/quantdashboard",
      priv: "TRANSACTION_SUMMARY",
    },
    {
      label: "Transaction Cost CONFIG",
      routerLink: "/transaction-cost-config",
      priv: "TRANSACTION_COST_CONFIG",
    },
    {
      label: "TRANSLATION DEFINITION",
      routerLink: "/translation",
      priv: "TRANSLATION_DEFINITION",
    },
    // U
    {
      label: "UPLOADED FILES",
      routerLink: "/uploadedfileslog",
      priv: "UPLOADED_FILES_LOG",
    },
    {
      label: "USERS",
      routerLink: "/users",
      icon: "fa fa-users",
      priv: "MANAGE_USERS",
    },
    {
      label: "USER GROUPS",
      routerLink: "/groups",
      icon: "fa fa-user",
      priv: "MANAGE_GROUPS",
    },
    // V
    // W
    // X
    // Y
    // Z
    // tps
		{
			'label': 'TRADE BLOTTER',
			'routerLink': '/tps/trade_processing_system',
			'priv': 'TRADE_BLOTTER'
		},
		{
			'label': 'SECURITY TYPE',
			'routerLink': '/tps/security_type',
			'priv': 'SECURITY_TYPE'
		},
		{
			'label': 'FA FUND & ACCOUNT',
			'routerLink': '/tps/fa_fund_&_account',
			'priv': 'FA_FUND_N_ACCOUNT'
		},
		{
			'label': 'BROKER SSI',
			'routerLink': '/tps/broker_ssi',
			'priv': 'BROKER_SSI'
		},
		{
			'label': 'MESSAGE HUB CONFIG',
			'routerLink': '/tps/message_hub_config',
			'priv': 'MESSAGE_HUB_CONFIG'
		},
		// {
		// 	'label': 'TRADE FILE UPLOAD',
		// 	'routerLink': '/tps/tps_file_uploads',
		// 	'priv': 'TRADE_FILE_UPLOAD'
		// },
		{
			'label': 'CODE CONFIG',
			'routerLink': '/tps/code_config',
			'priv': 'TPS_CODE_CONFIG'
		},
		{
			'label': 'INSTRUCTIONS CONFIG',
			'routerLink': '/tps/instructions_config',
			'priv': 'INSTRUCTIONS_CONFIG'
		},
		{
			'label': 'TRADE ELEMENTS CONFIG',
			'routerLink': '/tps/trade_element_config',
			'priv': 'TRADE_ELEMENT_CONFIG'
		},
		{
			'label': 'EXCEPTION MONITOR',
			'routerLink': '/tps/exception_monitor',
			'priv': 'EXCEPTION_MONITOR'
		},
		{
			'label': 'FA TEMPLATE MAPPING DEF',
			'routerLink': '/tps/fa_template_mapping_def',
			'priv': 'FA_TEMPLATE_MAPPING_DEF'
		},
    {
			'label': 'FORMAT CODE DEF',
			'routerLink': '/tps/format_code_def',
			'priv': 'FORMAT_CODE_DEF'
		},
    {
			'label': 'FORMAT CODE FIELD DEF',
			'routerLink': '/tps/format_code_field_def',
			'priv': 'FORMAT_CODE_FIELD_DEF'
		},
    {
			'label': 'EXPORT FILE',
			'routerLink': '/tps/export_file',
			'priv': 'EXPORT_FILE'
		},
    {
			'label': 'INSTRUCTION DEF',
			'routerLink': '/tps/instruction_def',
			'priv': 'INSTRUCTION_DEF'
		},
  ],
};
